import LifeIcon from './component'

export default LifeIcon
